import { type FC } from "react";

interface EngagementEmptyStateProps {
  message: string;
}

const EngagementEmptyState: FC<EngagementEmptyStateProps> = ({ message }) => (
  <div className="engagement-overview-empty" role="status">
    <p>{message}</p>
  </div>
);

export default EngagementEmptyState;
